// Maps insight-action ids that leave the PAR Intelligence drawer and open the
// full labor-schedule review/edit page, mirroring campaignActions.ts.
//
// Action ids are deterministic and shared between the live (backend-generated)
// and seed (static) insight cards, so a single id → flag is enough to wire both.

const LABOR_SCHEDULE_ACTION_IDS = new Set<string>(["act_demo_sos_labor_schedule"]);

export function opensLaborSchedule(actionId: string): boolean {
    return LABOR_SCHEDULE_ACTION_IDS.has(actionId);
}
